module.exports = __webpack_public_path__ + "static/media/EB-logo-word-only-2020.7d0ac2c5.png";